import { Button } from "@its-engineering-and-development/ui-foundation/components";

export function PolicyFormActions({
    hasChanges,
    isSaving = false,
    onCancel,
    onSave,
    className,
}: {
    hasChanges: boolean;
    isSaving?: boolean;
    onCancel: () => void;
    onSave: () => void;
    className?: string;
}) {
    return (
        <div className={`flex items-center justify-end gap-3 ${className ?? ""}`}>
            <Button color="secondary" size="md" onPress={onCancel} isDisabled={!hasChanges || isSaving}>
                Cancel
            </Button>
            <Button color="primary" size="md" onPress={onSave} isDisabled={!hasChanges || isSaving} isLoading={isSaving}>
                Save Changes
            </Button>
        </div>
    );
}
